import { render, staticRenderFns } from "./UpdateReminderEvent.vue?vue&type=template&id=03c1f905&"
import script from "./UpdateReminderEvent.vue?vue&type=script&lang=js&"
export * from "./UpdateReminderEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports